module.exports = __webpack_public_path__ + "img/icon05.e2a3cc8.png";